module.exports = __webpack_public_path__ + "img/pauli-x-root-12.015f3234.svg";